// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "files_videoplayer-" + chunkId + ".js?v=" + {"vendors-node_modules_video_js_dist_video_es_js":"f87ebe9feae884a73782","_34aa":"ab777726a58732acd0d2","css_style_css":"211b329b40ae32bf5d72","vendors-node_modules_video_js_dist_video-js_css":"6813c23d9e5029c0233b"}[chunkId] + "";
};